import React from 'react';
import {
  Spinner,
  Text,
  makeStyles,
  tokens,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: tokens.spacingVerticalL,
    padding: tokens.spacingVerticalXXL,
    minHeight: '200px',
  },
  message: {
    textAlign: 'center',
    color: tokens.colorNeutralForeground2,
  },
});

export interface ProgressSpinnerProps {
  message?: string;
}

export const ProgressSpinner: React.FC<ProgressSpinnerProps> = ({
  message = 'Submitting report...',
}) => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <Spinner size="large" />
      <Text className={styles.message}>{message}</Text>
    </div>
  );
};
